import api from 'config/api';

// eslint-disable-next-line import/prefer-default-export
export const listarVagas = (page = 1) => api.get(`/vagas/publico?page=${page}`);
export const filtrarVagas = query => api.get(`/vagas/publico?${query}`);
